import React, { useMemo, useState } from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { CountType, MessageConst } from 'enums'
import { AudienceAuthorsWidget as AudienceAuthorsWidgetType } from 'schemas/AudienceAuthorsWidgetSchema'
import { getLabel } from 'utils/widgetTypeUtil'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import AuthorsWidgetDataGuards from '../share/guards/AuthorsWidgetDataGuards'
import Table from '../share/Table'
import { convertToTableData, getNumberFormatter } from '../share/Table/utils'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../hooks'

const AudienceAuthorsWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceAuthorsWidgetType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)

  const countType = CountType.POSTS
  const [isModalOpen, setIsModalOpen] = useState(false)

  const {
    selectedInsights,
    detailSetting,
    handleRowClick,
    widgetSettingWithSelection
  } = useSelectedInsights(isModalOpen, widgetSetting, setIsModalOpen)

  const rowData = useMemo(() => convertToTableData(widgetData?.data, widgetSetting), [
    widgetData,
    widgetSetting
  ])

  const handleMentionsDisplay = (mentions: number | undefined) => {
    if (mentions) {
      return getNumberFormatter().format(mentions)
    }
    return MessageConst.EM_DASH
  }

  return (
    <UnexpectedErrorBoundary>
      <AuthorsWidgetDataGuards widgetId={widgetId} countType={countType}>
        <Table
          rowData={rowData}
          onMentionsHandle={handleMentionsDisplay}
          countType={countType}
          onRowClick={handleRowClick}
        />
      </AuthorsWidgetDataGuards>
      <InsightModal
        open={isModalOpen}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={countType}
        selectedInsights={selectedInsights}
        onClose={() => {
          setIsModalOpen(false)
        }}
        widgetSettingWithSelection={widgetSettingWithSelection}
        detailSetting={detailSetting}
      />
    </UnexpectedErrorBoundary>
  )
}

export default AudienceAuthorsWidget
